module.exports = ".modal-dialog.additives-modal {\n    max-width: calc(100% - 100px);\n    width: 70%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/components/modalFreshServiceOffboarding/modalFreshServiceOffboarding.css
// module id = ./src/app/views/consultants/components/modalFreshServiceOffboarding/modalFreshServiceOffboarding.css
// module chunks = main